import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import {
  updateOrganizationRequestAction,
  loadRulesRequestAction,
  loadAllOrganizationsRequestAction,
} from '@actions/organizations';
import {
  selectOrganizationsIsSubmitting,
  selectOrganizationsEditForm,
} from '@selectors/organizations';
import { getIntroMessagesRequestAction } from '@actions/introMessages';
import OrganizationEditPage from './OrganizationEditPage';

const mapStateToProps = (state) => ({
  isSubmitting: selectOrganizationsIsSubmitting(state),
  organizationsEditForm: selectOrganizationsEditForm(state),
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      updateOrganization: updateOrganizationRequestAction,
      loadRules: loadRulesRequestAction,
      loadAllOrganizations: loadAllOrganizationsRequestAction,
      getIntroMessages: getIntroMessagesRequestAction,
    },
    dispatch,
  ),
  goToOrganizations: () => dispatch(push(`/organizations/`)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizationEditPage);



// WEBPACK FOOTER //
// ./components/pages/OrganizationEditPage/index.js